var map = {
	"./kendo.messages.ar-AE": [
		81116,
		1116
	],
	"./kendo.messages.ar-AE.js": [
		81116,
		1116
	],
	"./kendo.messages.ar-BH": [
		22627,
		5008
	],
	"./kendo.messages.ar-BH.js": [
		22627,
		5008
	],
	"./kendo.messages.ar-DJ": [
		67180,
		7180
	],
	"./kendo.messages.ar-DJ.js": [
		67180,
		7180
	],
	"./kendo.messages.ar-DZ": [
		39932,
		9932
	],
	"./kendo.messages.ar-DZ.js": [
		39932,
		9932
	],
	"./kendo.messages.ar-EG": [
		65602,
		5602
	],
	"./kendo.messages.ar-EG.js": [
		65602,
		5602
	],
	"./kendo.messages.ar-ER": [
		87261,
		7261
	],
	"./kendo.messages.ar-ER.js": [
		87261,
		7261
	],
	"./kendo.messages.ar-IL": [
		84707,
		4707
	],
	"./kendo.messages.ar-IL.js": [
		84707,
		4707
	],
	"./kendo.messages.ar-IQ": [
		17256,
		7256
	],
	"./kendo.messages.ar-IQ.js": [
		17256,
		7256
	],
	"./kendo.messages.ar-JO": [
		82493,
		2493
	],
	"./kendo.messages.ar-JO.js": [
		82493,
		2493
	],
	"./kendo.messages.ar-KM": [
		39938,
		9938
	],
	"./kendo.messages.ar-KM.js": [
		39938,
		9938
	],
	"./kendo.messages.ar-KW": [
		78400,
		8400
	],
	"./kendo.messages.ar-KW.js": [
		78400,
		8400
	],
	"./kendo.messages.ar-LB": [
		80348,
		348
	],
	"./kendo.messages.ar-LB.js": [
		80348,
		348
	],
	"./kendo.messages.ar-LY": [
		48573,
		8573
	],
	"./kendo.messages.ar-LY.js": [
		48573,
		8573
	],
	"./kendo.messages.ar-MA": [
		54348,
		4348
	],
	"./kendo.messages.ar-MA.js": [
		54348,
		4348
	],
	"./kendo.messages.ar-MR": [
		91525,
		1525
	],
	"./kendo.messages.ar-MR.js": [
		91525,
		1525
	],
	"./kendo.messages.ar-OM": [
		99006,
		9006
	],
	"./kendo.messages.ar-OM.js": [
		99006,
		9006
	],
	"./kendo.messages.ar-PS": [
		20663,
		663
	],
	"./kendo.messages.ar-PS.js": [
		20663,
		663
	],
	"./kendo.messages.ar-QA": [
		52288,
		2288
	],
	"./kendo.messages.ar-QA.js": [
		52288,
		2288
	],
	"./kendo.messages.ar-SA": [
		37582,
		7582
	],
	"./kendo.messages.ar-SA.js": [
		37582,
		7582
	],
	"./kendo.messages.ar-SD": [
		4369,
		4369
	],
	"./kendo.messages.ar-SD.js": [
		4369,
		4369
	],
	"./kendo.messages.ar-SO": [
		64304,
		4304
	],
	"./kendo.messages.ar-SO.js": [
		64304,
		4304
	],
	"./kendo.messages.ar-SS": [
		62644,
		2644
	],
	"./kendo.messages.ar-SS.js": [
		62644,
		2644
	],
	"./kendo.messages.ar-SY": [
		6134,
		6134
	],
	"./kendo.messages.ar-SY.js": [
		6134,
		6134
	],
	"./kendo.messages.ar-TD": [
		79330,
		9330
	],
	"./kendo.messages.ar-TD.js": [
		79330,
		9330
	],
	"./kendo.messages.ar-TN": [
		48272,
		8272
	],
	"./kendo.messages.ar-TN.js": [
		48272,
		8272
	],
	"./kendo.messages.ar-YE": [
		80212,
		212
	],
	"./kendo.messages.ar-YE.js": [
		80212,
		212
	],
	"./kendo.messages.bg-BG": [
		30649,
		649
	],
	"./kendo.messages.bg-BG.js": [
		30649,
		649
	],
	"./kendo.messages.cs-CZ": [
		7732,
		7732
	],
	"./kendo.messages.cs-CZ.js": [
		7732,
		7732
	],
	"./kendo.messages.da-DK": [
		2383,
		2383
	],
	"./kendo.messages.da-DK.js": [
		2383,
		2383
	],
	"./kendo.messages.de-AT": [
		69115,
		9115
	],
	"./kendo.messages.de-AT.js": [
		69115,
		9115
	],
	"./kendo.messages.de-CH": [
		94317,
		4317
	],
	"./kendo.messages.de-CH.js": [
		94317,
		4317
	],
	"./kendo.messages.de-DE": [
		70761,
		761
	],
	"./kendo.messages.de-DE.js": [
		70761,
		761
	],
	"./kendo.messages.de-LI": [
		24885,
		4885
	],
	"./kendo.messages.de-LI.js": [
		24885,
		4885
	],
	"./kendo.messages.el-GR": [
		66545,
		6545
	],
	"./kendo.messages.el-GR.js": [
		66545,
		6545
	],
	"./kendo.messages.en-AU": [
		74332,
		4332
	],
	"./kendo.messages.en-AU.js": [
		74332,
		4332
	],
	"./kendo.messages.en-CA": [
		93070,
		3070
	],
	"./kendo.messages.en-CA.js": [
		93070,
		3070
	],
	"./kendo.messages.en-GB": [
		80799,
		799
	],
	"./kendo.messages.en-GB.js": [
		80799,
		799
	],
	"./kendo.messages.en-US": [
		32830,
		2830
	],
	"./kendo.messages.en-US.js": [
		32830,
		2830
	],
	"./kendo.messages.es-AR": [
		47816,
		7816
	],
	"./kendo.messages.es-AR.js": [
		47816,
		7816
	],
	"./kendo.messages.es-BO": [
		42856,
		2856
	],
	"./kendo.messages.es-BO.js": [
		42856,
		2856
	],
	"./kendo.messages.es-CL": [
		98308,
		8308
	],
	"./kendo.messages.es-CL.js": [
		98308,
		8308
	],
	"./kendo.messages.es-CO": [
		22893,
		2893
	],
	"./kendo.messages.es-CO.js": [
		22893,
		2893
	],
	"./kendo.messages.es-CR": [
		63050,
		3050
	],
	"./kendo.messages.es-CR.js": [
		63050,
		3050
	],
	"./kendo.messages.es-DO": [
		67893,
		274
	],
	"./kendo.messages.es-DO.js": [
		67893,
		274
	],
	"./kendo.messages.es-EC": [
		30707,
		707
	],
	"./kendo.messages.es-EC.js": [
		30707,
		707
	],
	"./kendo.messages.es-ES": [
		76995,
		6995
	],
	"./kendo.messages.es-ES.js": [
		76995,
		6995
	],
	"./kendo.messages.es-GT": [
		57832,
		7832
	],
	"./kendo.messages.es-GT.js": [
		57832,
		7832
	],
	"./kendo.messages.es-HN": [
		66717,
		6717
	],
	"./kendo.messages.es-HN.js": [
		66717,
		6717
	],
	"./kendo.messages.es-MX": [
		72758,
		2758
	],
	"./kendo.messages.es-MX.js": [
		72758,
		2758
	],
	"./kendo.messages.es-NI": [
		66026,
		6026
	],
	"./kendo.messages.es-NI.js": [
		66026,
		6026
	],
	"./kendo.messages.es-PA": [
		86776,
		6776
	],
	"./kendo.messages.es-PA.js": [
		86776,
		6776
	],
	"./kendo.messages.es-PE": [
		19396,
		9396
	],
	"./kendo.messages.es-PE.js": [
		19396,
		9396
	],
	"./kendo.messages.es-PR": [
		35937,
		5937
	],
	"./kendo.messages.es-PR.js": [
		35937,
		5937
	],
	"./kendo.messages.es-PY": [
		36992,
		6992
	],
	"./kendo.messages.es-PY.js": [
		36992,
		6992
	],
	"./kendo.messages.es-US": [
		53331,
		3331
	],
	"./kendo.messages.es-US.js": [
		53331,
		3331
	],
	"./kendo.messages.es-UY": [
		28221,
		8221
	],
	"./kendo.messages.es-UY.js": [
		28221,
		8221
	],
	"./kendo.messages.es-VE": [
		80246,
		246
	],
	"./kendo.messages.es-VE.js": [
		80246,
		246
	],
	"./kendo.messages.fa-IR": [
		95243,
		5243
	],
	"./kendo.messages.fa-IR.js": [
		95243,
		5243
	],
	"./kendo.messages.fi-FI": [
		41957,
		1957
	],
	"./kendo.messages.fi-FI.js": [
		41957,
		1957
	],
	"./kendo.messages.fr-BE": [
		30098,
		98
	],
	"./kendo.messages.fr-BE.js": [
		30098,
		98
	],
	"./kendo.messages.fr-CA": [
		4623,
		4623
	],
	"./kendo.messages.fr-CA.js": [
		4623,
		4623
	],
	"./kendo.messages.fr-CD": [
		51844,
		1844
	],
	"./kendo.messages.fr-CD.js": [
		51844,
		1844
	],
	"./kendo.messages.fr-CH": [
		99376,
		9376
	],
	"./kendo.messages.fr-CH.js": [
		99376,
		9376
	],
	"./kendo.messages.fr-CI": [
		40423,
		423
	],
	"./kendo.messages.fr-CI.js": [
		40423,
		423
	],
	"./kendo.messages.fr-CM": [
		56739,
		6739
	],
	"./kendo.messages.fr-CM.js": [
		56739,
		6739
	],
	"./kendo.messages.fr-FR": [
		19199,
		9199
	],
	"./kendo.messages.fr-FR.js": [
		19199,
		9199
	],
	"./kendo.messages.fr-HT": [
		52795,
		2795
	],
	"./kendo.messages.fr-HT.js": [
		52795,
		2795
	],
	"./kendo.messages.fr-LU": [
		11312,
		1312
	],
	"./kendo.messages.fr-LU.js": [
		11312,
		1312
	],
	"./kendo.messages.fr-MA": [
		53125,
		3125
	],
	"./kendo.messages.fr-MA.js": [
		53125,
		3125
	],
	"./kendo.messages.fr-MC": [
		62499,
		2499
	],
	"./kendo.messages.fr-MC.js": [
		62499,
		2499
	],
	"./kendo.messages.fr-ML": [
		53090,
		3090
	],
	"./kendo.messages.fr-ML.js": [
		53090,
		3090
	],
	"./kendo.messages.fr-SN": [
		86838,
		6838
	],
	"./kendo.messages.fr-SN.js": [
		86838,
		6838
	],
	"./kendo.messages.he-IL": [
		97615,
		7615
	],
	"./kendo.messages.he-IL.js": [
		97615,
		7615
	],
	"./kendo.messages.hr-HR": [
		37395,
		7395
	],
	"./kendo.messages.hr-HR.js": [
		37395,
		7395
	],
	"./kendo.messages.hu-HU": [
		95833,
		5833
	],
	"./kendo.messages.hu-HU.js": [
		95833,
		5833
	],
	"./kendo.messages.hy-AM": [
		46548,
		6548
	],
	"./kendo.messages.hy-AM.js": [
		46548,
		6548
	],
	"./kendo.messages.it-CH": [
		24479,
		4479
	],
	"./kendo.messages.it-CH.js": [
		24479,
		4479
	],
	"./kendo.messages.it-IT": [
		30345,
		345
	],
	"./kendo.messages.it-IT.js": [
		30345,
		345
	],
	"./kendo.messages.ja-JP": [
		29134,
		9134
	],
	"./kendo.messages.ja-JP.js": [
		29134,
		9134
	],
	"./kendo.messages.mk-MK": [
		97763,
		7763
	],
	"./kendo.messages.mk-MK.js": [
		97763,
		7763
	],
	"./kendo.messages.nb-NO": [
		67820,
		7820
	],
	"./kendo.messages.nb-NO.js": [
		67820,
		7820
	],
	"./kendo.messages.nl-BE": [
		65348,
		5348
	],
	"./kendo.messages.nl-BE.js": [
		65348,
		5348
	],
	"./kendo.messages.nl-NL": [
		51175,
		1175
	],
	"./kendo.messages.nl-NL.js": [
		51175,
		1175
	],
	"./kendo.messages.pl-PL": [
		92915,
		2915
	],
	"./kendo.messages.pl-PL.js": [
		92915,
		2915
	],
	"./kendo.messages.pt-BR": [
		13531,
		3531
	],
	"./kendo.messages.pt-BR.js": [
		13531,
		3531
	],
	"./kendo.messages.pt-PT": [
		76883,
		6883
	],
	"./kendo.messages.pt-PT.js": [
		76883,
		6883
	],
	"./kendo.messages.ro-RO": [
		10057,
		57
	],
	"./kendo.messages.ro-RO.js": [
		10057,
		57
	],
	"./kendo.messages.ru-RU": [
		42453,
		2453
	],
	"./kendo.messages.ru-RU.js": [
		42453,
		2453
	],
	"./kendo.messages.sk-SK": [
		30595,
		595
	],
	"./kendo.messages.sk-SK.js": [
		30595,
		595
	],
	"./kendo.messages.sq-AL": [
		91193,
		3574
	],
	"./kendo.messages.sq-AL.js": [
		91193,
		3574
	],
	"./kendo.messages.sr-Latn-RS": [
		12949,
		2949
	],
	"./kendo.messages.sr-Latn-RS.js": [
		12949,
		2949
	],
	"./kendo.messages.sv-SE": [
		69656,
		9656
	],
	"./kendo.messages.sv-SE.js": [
		69656,
		9656
	],
	"./kendo.messages.tr-TR": [
		16627,
		6627
	],
	"./kendo.messages.tr-TR.js": [
		16627,
		6627
	],
	"./kendo.messages.uk-UA": [
		99485,
		9485
	],
	"./kendo.messages.uk-UA.js": [
		99485,
		9485
	],
	"./kendo.messages.vi-VN": [
		87184,
		7184
	],
	"./kendo.messages.vi-VN.js": [
		87184,
		7184
	],
	"./kendo.messages.zh-CN": [
		4052,
		4052
	],
	"./kendo.messages.zh-CN.js": [
		4052,
		4052
	],
	"./kendo.messages.zh-HK": [
		82916,
		2916
	],
	"./kendo.messages.zh-HK.js": [
		82916,
		2916
	],
	"./kendo.messages.zh-TW": [
		34244,
		4244
	],
	"./kendo.messages.zh-TW.js": [
		34244,
		4244
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 93774;
module.exports = webpackAsyncContext;